import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Owned by G24 (plan.md S0). Pathless-content layout for the whole screen-group —
 * the register hub (`stores-transfers/index.tsx`) and the guided create/detail
 * flows (`stores-transfers/issues.*`, `stores-transfers/transfers.*`) render as
 * children here. */
export const Route = createFileRoute('/_authenticated/stores-transfers')({
  component: () => <Outlet />,
});
